module.exports = __webpack_public_path__ + "media/images/logo-service-f4cd59162ca36d1c240543c0362242d6.svg";